import TikToklogo from "../../assets/socialglass/TikTok-logo.svg";
import openpost from "../../assets/socialglass/open_post.png";
import x from "../../assets/socialglass/x.svg";
import instagram_logo from "../../assets/socialglass/instagram_icon.svg";
function PostBaseTemplate({
  platform,
  url,
  children,
  width = "400px",
  showPlatformName = true,
}) {
  const size = width < 400 ? 16 : width < 800 ? 24 : 32; // px
  const renderPlatformLogo = (platform, width) => {
    let sizeClass = "h-4 w-4"; // default
    if (width >= 640 && width < 1024) sizeClass = "h-6 w-6"; // tablet
    if (width >= 1024) sizeClass = "h-8 w-8"; // desktop

    switch (platform) {
      case "tiktok":
        return <img src={TikToklogo} alt="TikTok Logo" className={sizeClass} />;
      case "twitter":
        return <img src={x} alt="Twitter Logo" className={sizeClass} />;
      case "instagram":
        return (
          <img
            src={instagram_logo}
            alt="Instagram Logo"
            className={sizeClass}
          />
        );
      default:
        return null;
    }
  };

  const navigateToPost = () => {
    window.open(url, "_blank");
  };

  return (
    <div
      className="mx-auto mb-0 block h-fit rounded-[4px] pb-0"
      style={{ width: width, maxWidth: "100%" }}
    >
      <div className="inline-block w-full overflow-hidden rounded-lg border border-gray-200 bg-white">
        {/* Header */}
        <div className="flex border-none bg-white px-3 py-2">
          <div className="flex w-full items-center justify-between">
            {renderPlatformLogo(platform)}

            {showPlatformName && (
              <span
                style={{ fontSize: size * 0.35 }}
                className="ml-1 font-medium capitalize"
              >
                {platform}
              </span>
            )}
          </div>
        </div>

        {/* Post content */}
        <div className="w-full bg-white">{children}</div>

        {/* Footer */}
        <div className="flex items-center justify-between bg-black px-3 py-2">
          <p
            style={{ fontSize: size * 0.35 }}
            className="m-0 font-medium text-white"
          >
            View Post
          </p>
          <img
            src={openpost}
            onClick={navigateToPost}
            alt="Open Post"
            className="h-2 w-2 hover:cursor-pointer md:h-6 md:w-6"
          />
        </div>
      </div>
    </div>
  );
}

export default PostBaseTemplate;
